import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function SplitTextReveal({ text, className = "" }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (!textRef.current) return;

      const chars = text.split("");
      const charSpans = chars.map((char) => {
        const span = document.createElement("span");
        if (char === "\n") {
          span.innerHTML = "<br />";
          span.style.display = "block";
        } else {
          span.textContent = char === " " ? "\u00A0" : char;
          span.style.display = "inline-block";
        }
        span.style.opacity = char === "\n" ? "1" : "0";
        span.style.transform = char === "\n" ? "none" : "translateY(100%)";
        return span;
      });

      textRef.current.innerHTML = "";
      charSpans.forEach((span) => textRef.current.appendChild(span));

      const animatableSpans = charSpans.filter(
        (span) => span.textContent !== "" && !span.innerHTML.includes("<br")
      );
      gsap.set(animatableSpans, { opacity: 0, y: 100 });

      gsap.to(animatableSpans, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.03,
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse",
          markers: false,
        },
      });
    }, containerRef);

    return () => ctx.revert();
  }, [text]);

  return (
    <div ref={containerRef} className={`split-text-reveal ${className}`}>
      <h2 ref={textRef} className="split-text-content"></h2>
    </div>
  );
}
